// src/components/AvatarButton.js
import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { doc, onSnapshot } from 'firebase/firestore'; // Changed getDoc to onSnapshot for real-time updates
import QRCode from 'react-qr-code';
import './AvatarButton.css';

const AvatarButton = ({ user, handleLogout, onOpenAvatarModal }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [nickname, setNickname] = useState('');
  const [avatarImage, setAvatarImage] = useState(null); // <-- NEW state
  
  const dashboardUrl = window.location.href;

  useEffect(() => {
    if (!user) return;
    
    // Use onSnapshot to listen for real-time changes to the avatar
    const unsubscribe = onSnapshot(doc(db, 'users', user.uid), (doc) => {
      if (doc.exists()) {
        setNickname(doc.data().nickname);
        setAvatarImage(doc.data().avatarImage); // <-- Capture the image filename
      }
    });

    return () => unsubscribe();
  }, [user]);

  const getInitial = () => {
    if (nickname) return nickname.charAt(0).toUpperCase();
    if (user.email) return user.email.charAt(0).toUpperCase();
    return '?';
  };

  return (
    <div className="avatar-container">
      <button className="avatar-button" onClick={() => setIsOpen(!isOpen)}>
        {/* LOGIC: If avatarImage exists, show img tag, else show Initial */}
        {avatarImage ? (
          <img 
            src={`/avatars/${avatarImage}`} 
            alt="profile" 
            className="avatar-img-display" 
          />
        ) : (
          getInitial()
        )}
      </button>

      {isOpen && (
        <div className="avatar-menu">
          <div className="avatar-menu-header">
            <strong>{nickname || 'User'}</strong>
            <small>{user.email}</small>
          </div>
          
          {/* NEW: Button to open picker */}
          <button 
            className="menu-action-btn"
            onClick={() => {
              setIsOpen(false);
              onOpenAvatarModal();
            }}
          >
            Customize Avatar
          </button>

          <button className="logout-button" onClick={handleLogout}>
            Logout
          </button>
        </div>
      )}

      <div className="visible-qr-code-wrapper">
        <QRCode value={dashboardUrl} size={80} />
        <small>Scan to open</small>
      </div>
    </div>
  );
};

export default AvatarButton;